export default __webpack_public_path__ + "static/media/advantageshatteringattack.a3ec1106.png";